/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * ToolTipContent
 *
 * @file ToolTipContent.jsx
 * @author Mohamed yasar arabath M
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import mixins from '../../assets/styles/mixins.scss';


const useStyles = makeStyles(() => ({
  labelWrapper: {
    boxSizing: 'border-box',
    background: '#ffffff',
    borderRadius: 4,
    borderStyle: 'solid',
    borderColor: mixins.amethystLightColor,
    borderWidth: 1,
    padding: '2px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    flexShrink: 0,
    position: 'relative'
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexShrink: 0,
    position: 'relative'
  },
  tooltipText: {
    color: mixins.color_text_primary,
    textAlign: 'left',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    lineHeight: '20px',
    fontWeight: mixins.fontWeight400,
    position: 'relative'
  }
}));

const ToolTipContent = ({ text }) => {
  const classes = useStyles();

  return (
    <div className={classes.labelWrapper}>
      <div className={classes.textWrapper}>
        <div className={classes.tooltipText}>{text}</div>
      </div>
    </div>
  );
};

ToolTipContent.propTypes = {
  text: PropTypes.string.isRequired
};

export default ToolTipContent;
